module.exports = __webpack_public_path__ + "static/media/2DGACM5.3ac13c18.jpg";